/*
    Get map styles from https://snazzymaps.com/
    or write them yourself. that link is easier though.
*/

import mapStyles from './map-styles';

const mapElement = document.getElementById('venue_index_map') || document.getElementById('venue_map');

function renderMarkerContent(venue) {
  let popup = `<div class="map-popup u-mb--small">
                    <h4>${ venue.name }</h4>
                    <p>${ venue.address }</p>`;
  if (venue.venue_slug) {
    popup += `<p><a href="${ venue.venue_slug }">Find out more about this venue</a></p>`;
  }

  popup += `<p><a href="${ venue.event_slug }">See events at this venue</a></p>
                </div>`;

  return popup;
}

function initMap(conf) {
  const markerImage = '/static/images/map-marker.png';
  const { google } = window;

  const centerPoint = venueData.center;
  const mapPosition = new google.maps.LatLng(centerPoint.lat, centerPoint.lng);
  const mapOptions = {
    zoom: 15,
    minZoom: 6,
    maxZoom: 17,
    zoomControl: true,
    zoomControlOptions: {
      style: google.maps.ZoomControlStyle.TRUE,
    },
    center: mapPosition,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    draggable: window.innerWidth > 900,
    scrollwheel: false,
    panControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    overviewMapControl: false,
    rotateControl: false,
    styles: mapStyles[conf.theme],
  };

  const mapInitialiser = function mapInitialiser() {
    const map = new google.maps.Map(mapElement, mapOptions);
    const bounds = new google.maps.LatLngBounds();
    const image = new google.maps.MarkerImage(markerImage, null, null, null, new google.maps.Size(16, 24));

    venueData.venues.forEach(venue => {
      const position = new google.maps.LatLng(venue.lat, venue.lng);
      const venueMarker = new google.maps.Marker({
        position,
        icon: image,
        map,
      });

      const markerContent = renderMarkerContent(venue);
      const infowindow = new google.maps.InfoWindow({ content: markerContent });
      google.maps.event.addListener(venueMarker, 'click', () => {
        infowindow.open(map, venueMarker);
      });


      bounds.extend(position);
    });

    map.fitBounds(bounds);

    google.maps.event.addDomListener(window, 'resize', () => {
      map.setCenter(mapPosition);
      map.fitBounds(bounds);
    });
  };

  return mapInitialiser;
}


function init(conf) {
  if (window.google) {
    window.google.maps.event.addDomListener(window, 'load', initMap(conf));
  } else {
    mapElement.innerHTML = "<p class='u-text-center u-sentiment-error'>Google Maps API JS has not been loaded.</p>";
  }
}

export default { init };
